import { useEffect, useState } from 'react';
import { httpsCallable } from 'firebase/functions';
import { functions } from '../../lib/firebase';
import { REPORT_CALLABLE } from './reportContract';

interface Figure { count: number; valueCents: number }
export interface MovementPair {
  from: string;
  to: string;
  gapDays: number;
  carriedDeals: number;
  continuity: number;
  measurable: boolean;
  reachedLender: Figure;
  settled: Figure;
  lost: Figure;
  arrivedPastLender: Figure;
  disappeared: Figure;
  unresolvableDeals: number;
}
export type StageMovementResult =
  | { status: 'ok'; pairs: MovementPair[]; snapshotCount: number; unmeasurablePairs: number }
  | { status: 'insufficient_history'; snapshotCount: number };

export function useStageMovementReport(companyId: string) {
  const [result, setResult] = useState<StageMovementResult | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setResult(null);
    setError(null);
    const call = httpsCallable(functions, REPORT_CALLABLE);
    void call({ action: 'stageMovementReport', companyId }).then((response) => {
      if (!cancelled) setResult(response.data as StageMovementResult);
    }).catch(() => {
      if (!cancelled) setError('Stage milestones could not be loaded.');
    }).finally(() => {
      if (!cancelled) setLoading(false);
    });
    return () => { cancelled = true; };
  }, [companyId]);
  return { result, loading, error };
}
